import * as SiteApi from 'saas/sites/api';
import { createAction } from 'redux-actions';

export const fetchSitesAction = createAction('case.FETCH_SITES');
export const fetchSitesSuccessAction = createAction('case.FETCH_SITES_SUCCESS');
export const selectSiteAction = createAction('case.SELECT_SITE');
export const unselectSiteAction = createAction('case.UNSELECT_SITE');
export const addSiteAction = createAction('case.ADD_SITE');

export const fetchSites = customer => (dispatch, getState) => {
  const state = getState();
  if (state.sites.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchSitesAction());

  if (customer) {
    return SiteApi.getByCustomer(customer).then(response =>
      dispatch(fetchSitesSuccessAction(response))
    );
  } else {
    return dispatch(fetchSitesSuccessAction([]));
  }
};

export const selectSite = siteId => (dispatch, getState) => {
  dispatch(selectSiteAction(siteId));
};

export const unselectSite = site => (dispatch, getState) => {
  dispatch(unselectSiteAction(site));
};

export const addSite = site => (dispatch, getState) => {
  dispatch(addSiteAction(site));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/actions/sites.js